import { useEffect, useRef, useState } from "react";
import erodyWink from "../../../assets/erody_wink.svg";
import iconArrowRight from "../../../assets/icon_arrow_right.svg";
import { useNavigate } from "react-router-dom";
import "./LandingButton.scss";
import useSelectBrand from "../../../hooks/styles/useSelectBrand";
import useReactGASend from "../../../hooks/useReactGASend";

const LandingButton = () => {
  const navigate = useNavigate();
  const [showButton, setShowButton] = useState(false);
  const [buttonExpanded, setButtonExpanded] = useState(false);
  const btnRef = useRef(null);
  const { color } = useSelectBrand();

  const { makeEventTrackFn } = useReactGASend();

  const trackLinkClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };

  useEffect(() => {
    setTimeout(() => {
      setShowButton(true);
    }, 1000);

    const handleAnimationEnd = () => {
      setButtonExpanded(true);
    };

    const buttonEl = btnRef.current;
    if (buttonEl) {
      buttonEl.addEventListener("animationend", handleAnimationEnd);
    }

    return () => {
      if (buttonEl) {
        buttonEl.removeEventListener("animationend", handleAnimationEnd);
      }
    };
  }, []);

  return (
    <div
      ref={btnRef}
      className={`fixed z-10 bottom-12 right-5 btn-erody opacity-0 ${
        showButton ? "show" : ""
      }`}
    >
      <button
        onClick={() => {
          navigate("/chat");
          trackLinkClick("디지털상담 버튼 클릭");
        }}
        className={`overflow-hidden relative flex items-center justify-center w-20 h-20 px-1 rounded-full shadow min-w-20 bg-${color} ${
          buttonExpanded ? "expanded" : ""
        }`}
      >
        <span className="absolute z-10 flex items-center gap-2 text-lg font-semibold opacity-0 left-5 erody-txt ">
          디지털상담 가기 <img src={iconArrowRight} alt="" />
        </span>
        <span className="relative z-20">
          <img src={erodyWink} alt="" />
        </span>
      </button>
    </div>
  );
};

export default LandingButton;
